angular.module('mtic.components.login')
.directive('signin', function (
  $log,
  $timeout,
  API_CONFIG,
  TIMING_CONSTANTS,
  LocaleService,
  IAMManager,
  EventManager,
  userAccount,
  api,
  language,
  MticAlertModalService,
  PlatformService,
  cordovaMessenger
) {

  return {

    templateUrl: 'template.html',
    scope: {
          keepMoving: '=',
          username: '=?',
          fromSessionExpiry: '=?'
    },
    link: function (scope) {
      // event manager
      var eventManager = new EventManager('signin',scope);

      scope.is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      // $log.log('is iOs: ', scope.is_ios );
      scope.isSystemRequirementOpen = false;

      var WEB_EMBED_URL_SLUG = 'web-embed-connect';

      var token_saved_url = IAMManager.getSavedUrlParamsForToken();// This because on redirect, url params are erased
      // model

      // IAMManager.shouldPopup = false;
      if (window.location.href.indexOf(WEB_EMBED_URL_SLUG) !== -1 || token_saved_url.indexOf(WEB_EMBED_URL_SLUG) !== -1 || window.isWebEmbedConnect){
        scope.isWebEmbedded = true;
        IAMManager.shouldPopup = false;
      }else if(scope.is_ios || navigator.userAgent.match(/Android/i)){
        IAMManager.shouldPopup = false;
      }


      window.isWebEmbedConnect = scope.isWebEmbedded;

      scope.language = language;
      scope.finalzeIam = {
        active: false,
        role_type: null,
        profile: null
      }
      scope.loginForm = {
        username: null,
        password: null,
        isConnecting: false,
        isFailed: false
      }
      if (scope.username) {
        scope.loginForm.username = scope.username
      }

      scope.getIpCountryFailed = false;

      scope.show_login_button = false;
      var url = window.location.href;
      scope.show_saml = true;
      if(window.location.href.indexOf('force-no-saml') > -1){
        scope.show_saml = false;
      }else if(url.indexOf('new_saml_user') > -1){
        var new_user_params = JSON.parse(decodeURIComponent(url.split("new_saml_user=")[1]).replace(/\/"/g,'\\"'));
        new_user_params.oid = Math.random().toString(36).substr(3,10);
        new_user_params.unique_name = new_user_params.uuid;
        new_user_params.name = new_user_params.full_name;
        $log.log('NEW USER LOGIN ::  ', new_user_params);
        scope.finalzeIam.profile = new_user_params;
        scope.finalzeIam.role_type = new_user_params.account_type.indexOf('STUDENT') > -1 ? 'mtic_student' : 'mtic_teacher';
        scope.finalzeIam.active = true;
        document.location.hash = '';
      }
      if (url.indexOf('id_token=') !== -1){
        scope.show_login_button = false;
        //console.log('got url params : ', token_saved_url)
        var url_split = url.split('&');
        var id_token = url_split[0].split('id_token=')[1];
        
        var cached_profile = IAMManager.microsoft.client._extractIdToken(url_split[0].split('=')[1]);

        var saved_url_split = token_saved_url.split('#');
        document.location.hash = saved_url_split.length > 1 ? saved_url_split[1] : '';

        login_with_microsoft_profile(cached_profile);

         //scope.loginThroughMicrosoft()
        //console.log('here: ', IAMManager.microsoft.client.AcquireToken(id_token))
        //console.log('external redirect, id_token : ', url_split[0].split('=')[1])
      }else{
        scope.show_login_button = true;
      }

      eventManager.listen('done-login-attempt', function(){
        scope.show_login_button = true;
      })
      eventManager.listen('start-login-attempt', function(){
        scope.show_login_button = false;
      })
      eventManager.listen('post-iam-finalize', function(data){
        scope.finalzeIam.profile = data.profile;
        scope.finalzeIam.role_type = data.role_type;
        scope.finalzeIam.active = true;
      })

      scope.toggleExtendedIamExamples = function(){
        scope.isExtendedIamExamples = !scope.isExtendedIamExamples
      }

      scope.toggleSysReq = function(){
        scope.isSystemRequirementOpen = !scope.isSystemRequirementOpen;
        if (scope.isIAMEFVideo){
          $timeout(function(){
            document.getElementById('min-req-table').scrollTo(0,document.body.scrollHeight);
          },100)
        }
      }

      scope.toggleIAMEFVideo = function(){
        scope.isIAMEFVideo = !scope.isIAMEFVideo;
        if (scope.isIAMEFVideo){
          $timeout(function(){
            document.getElementById('ef-instr-video').scrollIntoView(false);
          },100)
        }
      }

      scope.mticInfoExpanded = false;
      scope.toggleMTICInfo = function(){
        scope.mticInfoExpanded = !scope.mticInfoExpanded;
      };

      scope.getCurrentLocale = function(){
        var curLocale = (scope.selected_country && scope.selected_country.code === 'LU') ? 'LUXEMBOURG' : LocaleService.getCurrentLocale();
        scope.isPortugalUser = scope.selected_country && scope.selected_country.code === 'PT';
        return curLocale;
      };

      scope.finalizeCheck = function(val){
        if(val === 'int'){
          scope.finalizeIamDoneInternational = true
        }else{
          scope.finalizeIamDoneLux = true
        }
      }


      var messageHandler = scope.messageHandler = {
        message: null,
        type: 'info',
        display: false,
        timeoutCancel: null,
        ext: '',
        hide(){
          messageHandler.display = false;
        },
        show(){
          messageHandler.display = true;
        },
        get(){
          return language.get(this.message) + this.ext;
        },
        getClass(){
          switch(messageHandler.type) {
            case 'success': return {'notification': true, 'is-success': true}
            case 'error':   return {'notification': true, 'is-danger': true}
            default:        return {'notification': true}
          }
        },
        set(langId, type='info', ext=null) {
          messageHandler.type = ['info','error','success'].indexOf(type) > -1 ? type : 'info';
          messageHandler.message = langId;
          $timeout(function(){
            messageHandler.show()
          }, TIMING_CONSTANTS.SCOPE_REFRESH_DELAY_MS);
          messageHandler.ext = ext ? ext : '';
          if(messageHandler.timeoutCancelToken){
            $timeout.cancel(messageHandler.timeoutCancelToken)
          }
          messageHandler.timeoutCancelToken = $timeout(messageHandler.hide, TIMING_CONSTANTS.MESSAGE_HIDE_DELAY_MS)
        }
      }

      scope.resetValidation = function () {
        scope.loginForm.isConnecting = false;
        scope.loginForm.isFailed = false;
      }

      scope.openForgotPassword = function(){
        scope.recoveryEmailSent = false;
        scope.forgotPwd = true;
      }
      scope.closeForgotPassword = function(){
        scope.forgotPwd = false;
      }
      scope.sendPasswordRecoveryEmail = function(){
        scope.recoveryEmailSent = true;
      }

      scope.attemptLogin = function () {
        eventManager.broadcast('start-login-attempt');
        scope.loginForm.isFailed = false;
        scope.loginForm.isConnecting = true;
        // console.log(window.location.href, window.location.href.indexOf('web-embed-connect'))
        //if (window.location.href.indexOf(WEB_EMBED_URL_SLUG) !== -1){
          //window.isWebEmbedConnect = scope.isWebEmbedded;
        //}
        // $log.log('[[signin]]', scope.loginForm.username, scope.loginForm.password, !!scope.username, scope.keepMoving)
        api.login({
          uuid: scope.loginForm.username,
          password: scope.loginForm.password,
          dueToExpiry: !!scope.username,
          keepMoving: scope.keepMoving
        }).then(()=>{
          eventManager.broadcast('done-login-attempt')
        }).catch(()=>{
          eventManager.broadcast('done-login-attempt')
        })
      }
      scope.onNoAccount = function(){
          eventManager.broadcast('login:open', 'signup')
      }
      scope.loginThroughGoogle = function(){
        window.alert('Google login not available at this time.');
      }
      scope.loginThroughFacebook = function(){
        window.alert('Facebook login not available at this time.');
      }
      scope.hide_ios_notification = function(){
        scope.show_ios_app_login_redirect = false;
      }
      scope.loginThroughSaml = function(){
        var hash_params = window.location.href.split('/#');
        var relayState = encodeURIComponent(JSON.stringify({
          redirectTo: window.location.href.replace(/#.*$/, ''),
          urlHash: hash_params.length > 1 ? hash_params[1].replace('/',''):'',
          forApp: PlatformService.isApp
        }));
        var samlLoginUrl = API_CONFIG.REMOTE_API + '/saml/login' + '?RelayState=' + relayState;
        if (PlatformService.isApp) {
          cordovaMessenger.requestResponse('requestSamlLogin', { samlLoginUrl }).then((response) => {
            $log.log('loginThroughSaml response', arguments);
            if (!response) {
              $log.debug('saml login cancelled');
              return;
            }
            response.payload.data.isSamlUser = true;
            document.location.hash = response.payload.messageType + '='+JSON.stringify(response.payload.data);
            window.location.reload();
          }).catch((err) => {
            $log.error(err, 'saml login cancelled');
          });
        } else {
          window.location.href = samlLoginUrl;
        }
      }
      scope.loginThroughMicrosoft = function(){
        //IAM LOGIN:
        if (!PlatformService.isApp) {
          scope.offline_post_submission = false;
          if(!navigator.onLine){
            $timeout(function(){
              scope.offline_post_submission = true;
            }, 200)
            return;
          }
          messageHandler.set(8147, 'info');
          eventManager.broadcast('start-login-attempt');
        }

        IAMManager.login().then(function(data){
          login_with_microsoft_profile(data.profile);
        }).catch(function(err){
          $log.debug(err);
          eventManager.broadcast('done-login-attempt');
        })
      }

      function login_with_microsoft_profile(profile){
        // $log.log('[[signin]] LoggedIn to microsoft!', profile)
        eventManager.broadcast('start-login-attempt');
        scope.finalzeIam.profile = profile;
        api.login({
          uuid: profile.unique_name,
          password: profile.oid,
          dueToExpiry: !!scope.username,
          keepMoving: scope.keepMoving,
          auth_type: 'microsoftStrategy',
          dontCatch: true
        })
        .then( res => {
          // $log.log('[[signin]] Microsoft Login sucessful', res);
          eventManager.broadcast('done-login-attempt');
          LocaleService.setCurrentLocale('LUXEMBOURG');
          LocaleService.setAsIamUser();
        })
        .catch( (err) => {
          eventManager.broadcast('done-login-attempt')
          //$log.log('[[signin]] Login issue failed', err);
          if(err.message === 'NOT_FOUND__USER_AUTHS') {
            api.validateIAM(profile)
            .then( function(data) {
              // $log.log('api.validateIAM', data);
              scope.finalzeIam.role_type = data.role_type
              scope.finalzeIam.active = true
            })
            .catch( function(err) {
              // $log.log('api.validateIAM FAIL');
              MticAlertModalService.set(err.message, {
                title: 'Microsoft Login',
                callback: function(){
                  userAccount.logout()
                }
              })
              $log.debug('[[signin]]', err)
            });
          }
          else{
            messageHandler.set(8155, 'error')
            // if(err === 'FAILED_TO_CONNECT' || err.message === 'FAILED_TO_CONNECT'){
            //   window.alert('You are not connected to the internet, please try again!')
            // }
            $log.debug('[[signin]]',{err})
          }
        })
      }


      if (API_CONFIG.debugLogin) {
        $timeout(function(){
          scope.loginForm.username = API_CONFIG.debugLogin.username;
          scope.loginForm.password = API_CONFIG.debugLogin.password;
          scope.attemptLogin();
        }, TIMING_CONSTANTS.PRE_DEBUG_AUTOACTION_MS);
      }

      //scope.selected_country = {name: 'Select Your Country'};
      scope.country_box_focus = false;
      scope.name_object = {};
      scope.name_object.country_name_filter = '';

        // scope.$watch('selected_country.name', function(val){
        //   console.log('country change : ', val)
        // })
      var cancel_touch = false
      scope.setCountry = function(country){
        scope.getIpCountryFailed = false;
        scope.selected_country = country;
        scope.country_box_focus = false;
        scope.name_object.country_name_filter = '';
        scope.filter_countries();
        if(country.code === 'LU'){
          LocaleService.setCurrentLocale('LUXEMBOURG');
        }
        else{
          var browserLanguage = window.navigator.language;
          if (browserLanguage){
            var browserLanguageShort = browserLanguage.split('-')[0]
            switch (browserLanguageShort){
              case 'en':
                // language.set($cookies.get('bar_language') || 'en', true);
                if(!userAccount.isLanguageSetThroughProfile()){
                  language.set('en', true);
                }
              break;
            }
          }
        }
        // cancel_touch = true;
        // $timeout(function(){
        //   cancel_touch = false;
        // }, 500)
      }

      $timeout(function(){
        location_callback();
      }, 1000)

      var location_callback = function(){
        var ip_based = LocaleService.getIpBasedCountry();
        if(ip_based){
          scope.countries_list.forEach(function(country){
            if(country.code === ip_based && scope.selected_country !== country){
              scope.setCountry(country);
            }
          })
        }else{
          scope.selected_country = {name:'Click to select your country...'}
          scope.getIpCountryFailed = true;
        }
      }

      LocaleService.registerObserver(location_callback)


      scope.expandCountryBox = function(bool, clear){
        $timeout(function(){
          // if(cancel_touch) return;
          scope.country_box_focus = bool;
          if(clear){
            scope.name_object.country_name_filter = '';
            scope.filter_countries();
          }
          if(bool){
            $timeout(function(){
              document.getElementById('country_filter_input').focus();
            }, 200)
          }
          // if(bool && scope.selected_country.name){
            // $timeout(function(){
            //   var myElement = document.getElementById('country_id_'+scope.selected_country.code);
            //   if(myElement){
            //     var topPos = myElement.offsetTop;
            //     document.getElementById('big_country_box').scrollTop = topPos - 44;
            //   }
            // }, 200)
          // }
        }, 200)
      }


      scope.filter_countries =  function(val){
        if(!val || val.trim() === ''){
          scope.countries_list_filtered = scope.countries_list;
          //scope.selected_country = {name: 'Select Your Country'};
        }else{
          scope.countries_list_filtered = [];
          scope.countries_list.forEach(function(country){
            var lc_name = country.name.toLowerCase();
            if(lc_name.match(val.toLowerCase())){
              scope.countries_list_filtered.push(country);
            }
          })
        }
      }

      scope.focusItem = function(elementId){
        document.getElementById(elementId).scrollIntoView(true);
      }

      scope.getSystemVersion = function(){
        return 'v7.43.29-rc.110'
      }

      scope.countries_list = [
      {"name": "Afghanistan", "code": "AF"},
      {"name": "Aland Islands", "code": "AX"},
      {"name": "Albania", "code": "AL"},
      {"name": "Algeria", "code": "DZ"},
      {"name": "American Samoa", "code": "AS"},
      {"name": "AndorrA", "code": "AD"},
      {"name": "Angola", "code": "AO"},
      {"name": "Anguilla", "code": "AI"},
      {"name": "Antarctica", "code": "AQ"},
      {"name": "Antigua and Barbuda", "code": "AG"},
      {"name": "Argentina", "code": "AR"},
      {"name": "Armenia", "code": "AM"},
      {"name": "Aruba", "code": "AW"},
      {"name": "Australia", "code": "AU"},
      {"name": "Austria", "code": "AT"},
      {"name": "Azerbaijan", "code": "AZ"},
      {"name": "Bahamas", "code": "BS"},
      {"name": "Bahrain", "code": "BH"},
      {"name": "Bangladesh", "code": "BD"},
      {"name": "Barbados", "code": "BB"},
      {"name": "Belarus", "code": "BY"},
      {"name": "Belgium", "code": "BE"},
      {"name": "Belize", "code": "BZ"},
      {"name": "Benin", "code": "BJ"},
      {"name": "Bermuda", "code": "BM"},
      {"name": "Bhutan", "code": "BT"},
      {"name": "Bolivia", "code": "BO"},
      {"name": "Bosnia and Herzegovina", "code": "BA"},
      {"name": "Botswana", "code": "BW"},
      {"name": "Bouvet Island", "code": "BV"},
      {"name": "Brazil", "code": "BR"},
      {"name": "British Indian Ocean Territory", "code": "IO"},
      {"name": "Brunei Darussalam", "code": "BN"},
      {"name": "Bulgaria", "code": "BG"},
      {"name": "Burkina Faso", "code": "BF"},
      {"name": "Burundi", "code": "BI"},
      {"name": "Cambodia", "code": "KH"},
      {"name": "Cameroon", "code": "CM"},
      {"name": "Canada", "code": "CA"},
      {"name": "Cape Verde", "code": "CV"},
      {"name": "Cayman Islands", "code": "KY"},
      {"name": "Central African Republic", "code": "CF"},
      {"name": "Chad", "code": "TD"},
      {"name": "Chile", "code": "CL"},
      {"name": "China", "code": "CN"},
      {"name": "Christmas Island", "code": "CX"},
      {"name": "Cocos Islands", "code": "CC"},
      {"name": "Colombia", "code": "CO"},
      {"name": "Comoros", "code": "KM"},
      {"name": "Republic of the Congo", "code": "CG"},
      {"name": "Democratic Republic of the Congo", "code": "CD"},
      {"name": "Cook Islands", "code": "CK"},
      {"name": "Costa Rica", "code": "CR"},
      {"name": "Cote D'Ivoire", "code": "CI"},
      {"name": "Croatia", "code": "HR"},
      {"name": "Cuba", "code": "CU"},
      {"name": "Cyprus", "code": "CY"},
      {"name": "Czech Republic", "code": "CZ"},
      {"name": "Denmark", "code": "DK"},
      {"name": "Djibouti", "code": "DJ"},
      {"name": "Dominica", "code": "DM"},
      {"name": "Dominican Republic", "code": "DO"},
      {"name": "Ecuador", "code": "EC"},
      {"name": "Egypt", "code": "EG"},
      {"name": "El Salvador", "code": "SV"},
      {"name": "Equatorial Guinea", "code": "GQ"},
      {"name": "Eritrea", "code": "ER"},
      {"name": "Estonia", "code": "EE"},
      {"name": "Ethiopia", "code": "ET"},
      {"name": "Falkland Islands", "code": "FK"},
      {"name": "Faroe Islands", "code": "FO"},
      {"name": "Fiji", "code": "FJ"},
      {"name": "Finland", "code": "FI"},
      {"name": "France", "code": "FR"},
      {"name": "French Guiana", "code": "GF"},
      {"name": "French Polynesia", "code": "PF"},
      {"name": "French Southern Territories", "code": "TF"},
      {"name": "Gabon", "code": "GA"},
      {"name": "Gambia", "code": "GM"},
      {"name": "Georgia", "code": "GE"},
      {"name": "Germany", "code": "DE"},
      {"name": "Ghana", "code": "GH"},
      {"name": "Gibraltar", "code": "GI"},
      {"name": "Greece", "code": "GR"},
      {"name": "Greenland", "code": "GL"},
      {"name": "Grenada", "code": "GD"},
      {"name": "Guadeloupe", "code": "GP"},
      {"name": "Guam", "code": "GU"},
      {"name": "Guatemala", "code": "GT"},
      {"name": "Guernsey", "code": "GG"},
      {"name": "Guinea", "code": "GN"},
      {"name": "Guinea Bissau", "code": "GW"},
      {"name": "Guyana", "code": "GY"},
      {"name": "Haiti", "code": "HT"},
      {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
      {"name": "Vatican City", "code": "VA"},
      {"name": "Honduras", "code": "HN"},
      {"name": "Hong Kong", "code": "HK"},
      {"name": "Hungary", "code": "HU"},
      {"name": "Iceland", "code": "IS"},
      {"name": "India", "code": "IN"},
      {"name": "Indonesia", "code": "ID"},
      {"name": "Iran", "code": "IR"},
      {"name": "Iraq", "code": "IQ"},
      {"name": "Ireland", "code": "IE"},
      {"name": "Isle of Man", "code": "IM"},
      {"name": "Israel", "code": "IL"},
      {"name": "Italy", "code": "IT"},
      {"name": "Jamaica", "code": "JM"},
      {"name": "Japan", "code": "JP"},
      {"name": "Jersey", "code": "JE"},
      {"name": "Jordan", "code": "JO"},
      {"name": "Kazakhstan", "code": "KZ"},
      {"name": "Kenya", "code": "KE"},
      {"name": "Kiribati", "code": "KI"},
      {"name": "South Korea", "code": "KP"},
      {"name": "North Korea", "code": "KR"},
      {"name": "Kuwait", "code": "KW"},
      {"name": "Kyrgyzstan", "code": "KG"},
      {"name": "Laos", "code": "LA"},
      {"name": "Latvia", "code": "LV"},
      {"name": "Lebanon", "code": "LB"},
      {"name": "Lesotho", "code": "LS"},
      {"name": "Liberia", "code": "LR"},
      {"name": "Libya", "code": "LY"},
      {"name": "Liechtenstein", "code": "LI"},
      {"name": "Lithuania", "code": "LT"},
      {"name": "Luxembourg", "code": "LU"},
      {"name": "Macao", "code": "MO"},
      {"name": "Macedonia", "code": "MK"},
      {"name": "Madagascar", "code": "MG"},
      {"name": "Malawi", "code": "MW"},
      {"name": "Malaysia", "code": "MY"},
      {"name": "Maldives", "code": "MV"},
      {"name": "Mali", "code": "ML"},
      {"name": "Malta", "code": "MT"},
      {"name": "Marshall Islands", "code": "MH"},
      {"name": "Martinique", "code": "MQ"},
      {"name": "Mauritania", "code": "MR"},
      {"name": "Mauritius", "code": "MU"},
      {"name": "Mayotte", "code": "YT"},
      {"name": "Mexico", "code": "MX"},
      {"name": "Micronesia", "code": "FM"},
      {"name": "Moldova", "code": "MD"},
      {"name": "Monaco", "code": "MC"},
      {"name": "Mongolia", "code": "MN"},
      {"name": "Montenegro", "code": "ME"},
      {"name": "Montserrat", "code": "MS"},
      {"name": "Morocco", "code": "MA"},
      {"name": "Mozambique", "code": "MZ"},
      {"name": "Myanmar", "code": "MM"},
      {"name": "Namibia", "code": "NA"},
      {"name": "Nauru", "code": "NR"},
      {"name": "Nepal", "code": "NP"},
      {"name": "Netherlands", "code": "NL"},
      //{"name": "Netherlands Antilles", "code": "AN"},
      {"name": "New Caledonia", "code": "NC"},
      {"name": "New Zealand", "code": "NZ"},
      {"name": "Nicaragua", "code": "NI"},
      {"name": "Niger", "code": "NE"},
      {"name": "Nigeria", "code": "NG"},
      {"name": "Niue", "code": "NU"},
      {"name": "Norfolk Island", "code": "NF"},
      {"name": "Northern Mariana Islands", "code": "MP"},
      {"name": "Norway", "code": "NO"},
      {"name": "Oman", "code": "OM"},
      {"name": "Pakistan", "code": "PK"},
      {"name": "Palau", "code": "PW"},
      {"name": "Palestinian Territory", "code": "PS"},
      {"name": "Panama", "code": "PA"},
      {"name": "Papua New Guinea", "code": "PG"},
      {"name": "Paraguay", "code": "PY"},
      {"name": "Peru", "code": "PE"},
      {"name": "Philippines", "code": "PH"},
      {"name": "Pitcairn Islands", "code": "PN"},
      {"name": "Poland", "code": "PL"},
      {"name": "Portugal", "code": "PT"},
      {"name": "Puerto Rico", "code": "PR"},
      {"name": "Qatar", "code": "QA"},
      {"name": "Reunion", "code": "RE"},
      {"name": "Romania", "code": "RO"},
      {"name": "Russia", "code": "RU"},
      {"name": "RWANDA", "code": "RW"},
      {"name": "Saint Helena", "code": "SH"},
      {"name": "Saint Kitts and Nevis", "code": "KN"},
      {"name": "Saint Lucia", "code": "LC"},
      {"name": "Saint Pierre and Miquelon", "code": "PM"},
      {"name": "Saint Vincent and the Grenadines", "code": "VC"},
      {"name": "Samoa", "code": "WS"},
      {"name": "San Marino", "code": "SM"},
      {"name": "Sao Tome and Principe", "code": "ST"},
      {"name": "Saudi Arabia", "code": "SA"},
      {"name": "Senegal", "code": "SN"},
      {"name": "Serbia", "code": "RS"},
      {"name": "Seychelles", "code": "SC"},
      {"name": "Sierra Leone", "code": "SL"},
      {"name": "Singapore", "code": "SG"},
      {"name": "Slovakia", "code": "SK"},
      {"name": "Slovenia", "code": "SI"},
      {"name": "Solomon Islands", "code": "SB"},
      {"name": "Somalia", "code": "SO"},
      {"name": "South Africa", "code": "ZA"},
      {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
      {"name": "Spain", "code": "ES"},
      {"name": "Sri Lanka", "code": "LK"},
      {"name": "Sudan", "code": "SD"},
      {"name": "Suriname", "code": "SR"},
      {"name": "Svalbard and Jan Mayen", "code": "SJ"},
      {"name": "Swaziland", "code": "SZ"},
      {"name": "Sweden", "code": "SE"},
      {"name": "Switzerland", "code": "CH"},
      {"name": "Syria", "code": "SY"},
      {"name": "Taiwan", "code": "TW"},
      {"name": "Tajikistan", "code": "TJ"},
      {"name": "Tanzania", "code": "TZ"},
      {"name": "Thailand", "code": "TH"},
      {"name": "East Timor", "code": "TL"},
      {"name": "Togo", "code": "TG"},
      {"name": "Tokelau", "code": "TK"},
      {"name": "Tonga", "code": "TO"},
      {"name": "Trinidad and Tobago", "code": "TT"},
      {"name": "Tunisia", "code": "TN"},
      {"name": "Turkey", "code": "TR"},
      {"name": "Turkmenistan", "code": "TM"},
      {"name": "Turks and Caicos Islands", "code": "TC"},
      {"name": "Tuvalu", "code": "TV"},
      {"name": "Uganda", "code": "UG"},
      {"name": "Ukraine", "code": "UA"},
      {"name": "United Arab Emirates", "code": "AE"},
      {"name": "United Kingdom", "code": "GB"},
      {"name": "United States of America", "code": "US"},
      //{"name": "United States Minor Outlying Islands", "code": "UM"},
      {"name": "Uruguay", "code": "UY"},
      {"name": "Uzbekistan", "code": "UZ"},
      {"name": "Vanuatu", "code": "VU"},
      {"name": "Venezuela", "code": "VE"},
      {"name": "VietNam", "code": "VN"},
      {"name": "Virgin Islands British", "code": "VG"},
      {"name": "Virgin Islands US", "code": "VI"},
      {"name": "Wallis and Futuna", "code": "WF"},
      {"name": "Western Sahara", "code": "EH"},
      {"name": "Yemen", "code": "YE"},
      {"name": "Zambia", "code": "ZM"},
      {"name": "Zimbabwe", "code": "ZW"}
      ]

      scope.countries_list_filtered = scope.countries_list;


    }
  }
})
